'use client';

import HomePage from "./home";

/**
 * Client Component - Entry point
 */
export default function Home() {
  return <HomePage />;
}
